<template>
  <el-tabs
    class="tab-content"
    v-model="activeTab"
    type="card"
    @tab-remove="removeTab"
  >
    <el-tab-pane label="实体列表" name="entityList">
      <entity-list @entityClick="addTab" @entityDelete="removeTab" />
    </el-tab-pane>
    <el-tab-pane
      v-for="item in tabs"
      :key="item.name"
      :label="item.name"
      :name="item.name"
      closable
    >
      <site-live :propData="item" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import EntityList from "./entityList.vue";
import SiteLive from "./siteLive.vue";
export default {
  name: "TabContent",
  components: {
    EntityList,
    SiteLive
  },
  data() {
    return {
      activeTab: "entityList",
      tabs: []
    };
  },
  methods: {
    addTab(row) {
      let index = this.tabs.findIndex(data => data.name === row.name);
      if (index >= 0) {
        return (this.activeTab = row.name);
      }
      this.tabs.push(row);
      this.activeTab = row.name;
    },
    removeTab(name) {
      let index = this.tabs.findIndex(data => data.name === name);
      if (index >= 0) {
        this.tabs.splice(index, 1);
        this.activeTab = "entityList";
      }
    }
  }
};
</script>

<style>
.tab-content {
  height: 100%;
}
</style>
